export const restaurants = [{
		"id": "1",
		"location": "园博喜街2栋",
		"name": "东门超市",
		"type": "超市",
		"longitude": 112.1801547584937,
		"latitude": 31.011605186739846,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/1.jpg",
		"distance": ""
	},
	{
		"id": "2",
		"location": "园博喜街2栋",
		"name": "鑫鑫超市",
		"type": "超市",
		"longitude": 112.18074356535499,
		"latitude": 31.010563079192824,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/2.jpg",
		"distance": ""
	},
	{
		"id": "3",
		"location": "园博喜街2栋",
		"name": "楚松园",
		"type": "大型餐饮",
		"longitude": 112.1808180133773,
		"latitude": 31.010242490807467,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/3.jpg",
		"distance": ""
	},
	{
		"id": "4",
		"location": "园博喜街3栋",
		"name": "田阿姨私房菜",
		"type": "大型餐饮",
		"longitude": 112.18058743397182,
		"latitude": 31.010612988452614,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/4.jpg",
		"distance": ""
	},
	{
		"id": "5",
		"location": "园博喜街3栋",
		"name": "甜甜烘焙",
		"type": "烘焙店",
		"longitude": 112.18053685069742,
		"latitude": 31.01070833867567,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/5.jpg",
		"distance": ""
	},
	{
		"id": "6",
		"location": "园博喜街4栋",
		"name": "潇湘食尊",
		"type": "大型餐饮",
		"longitude": 112.17967399240956,
		"latitude": 31.011861599580595,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/6.jpg",
		"distance": ""
	},
	{
		"id": "7",
		"location": "花街ABC栋",
		"name": "荆品名门",
		"type": "综合商业体",
		"longitude": 112.18036589346116,
		"latitude": 31.01056564816435,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/7.jpg",
		"distance": ""
	},
	{
		"id": "8",
		"location": "荆山驿",
		"name": "休闲餐吧",
		"type": "轻食",
		"longitude": 112.17297894217415,
		"latitude": 31.0137091014006,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/8.jpg",
		"distance": ""
	},
	{
		"id": "9",
		"location": "菊花驿",
		"name": "小虎堂",
		"type": "烘焙",
		"longitude": 112.17340514535522,
		"latitude": 31.014316439240833,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/9.jpg",
		"distance": ""
	},
	{
		"id": "10",
		"location": "桃花驿",
		"name": "餐饮",
		"type": "堂食",
		"longitude": 112.1734051453552,
		"latitude": 31.017344974318537,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/10.jpg",
		"distance": ""
	},
	{
		"id": "11",
		"location": "百合驿",
		"name": "荆派乐园",
		"type": "零售",
		"longitude": 112.17614510312933,
		"latitude": 31.015852664493558,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/11.jpg",
		"distance": ""
	},
	{
		"id": "12",
		"location": "宜昌园",
		"name": "气球、非遗",
		"type": "零售",
		"longitude": 112.17436858040946,
		"latitude": 31.01334035329149,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/12.jpg",
		"distance": ""
	},
	{
		"id": "13",
		"location": "博物馆一楼",
		"name": "文创商品",
		"type": "零售",
		"longitude": 112.17998197067959,
		"latitude": 31.006950530653036,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/13.jpg",
		"distance": ""
	},
	{
		"id": "14",
		"location": "时光市集4号",
		"name": "棉花糖",
		"type": "零售",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/14.jpg",
		"distance": ""
	},
	{
		"id": "15",
		"location": "时光市集5号",
		"name": "特产便利店",
		"type": "零售",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/15.jpg",
		"distance": ""
	},
	{
		"id": "16",
		"location": "时光市集6号",
		"name": "网红大可乐",
		"type": "水吧",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/16.jpg",
		"distance": ""
	},
	{
		"id": "17",
		"location": "时光市集7号",
		"name": "百特茶",
		"type": "水吧",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/17.jpg",
		"distance": ""
	},
	{
		"id": "18",
		"location": "时光市集8号",
		"name": "文创雪糕",
		"type": "零售",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/18.jpg",
		"distance": ""
	},
	{
		"id": "19",
		"location": "时光市集9号",
		"name": "淄博烧烤",
		"type": "小吃",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/19.jpg",
		"distance": ""
	},
	{
		"id": "20",
		"location": "时光市集11号",
		"name": "长沙臭豆腐",
		"type": "小吃",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/20.jpg",
		"distance": ""
	},
	{
		"id": "21",
		"location": "时光市集12号",
		"name": "炒酸奶",
		"type": "小吃",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/21.jpg",
		"distance": ""
	},
	{
		"id": "22",
		"location": "时光市集13号",
		"name": "9.9元小串",
		"type": "小吃",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/22.jpg",
		"distance": ""
	},
	{
		"id": "23",
		"location": "时光市集14号",
		"name": "盼哥豆花",
		"type": "小吃",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/23.jpg",
		"distance": ""
	},
	{
		"id": "24",
		"location": "时光市集47号",
		"name": "襄阳牛肉面",
		"type": "小吃",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/24.jpg",
		"distance": ""
	},
	{
		"id": "25",
		"location": "时光市集48号",
		"name": "桥头排骨",
		"type": "小吃",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/25.jpg",
		"distance": ""
	},
	{
		"id": "26",
		"location": "时光市集51号",
		"name": "关东煮",
		"type": "小吃",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/26.jpg",
		"distance": ""
	},
	{
		"id": "27",
		"location": "时光市集52号",
		"name": "8090怀旧零食铺",
		"type": "零售",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/27.jpg",
		"distance": ""
	},
	{
		"id": "28",
		"location": "时光市集53号",
		"name": "公安锅盔",
		"type": "小吃",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/28.jpg",
		"distance": ""
	},
	{
		"id": "29",
		"location": "时光市集54号",
		"name": "邓氏阿嬷手作",
		"type": "水吧",
		"longitude": 112.17385810292387,
		"latitude": 31.01691556710961,
		"imgPath": "https://farm.evcc.top/Uploads/yuanboyuan/foods/29.jpg",
		"distance": ""
	}
]